<template id="conmmissioned">
  <v-card>
    <v-layout justify-center>
      <!--タイトル-->
      <v-card-title class="head">
        {{ title }}
        <v-icon color="indigo">
          {{ icon }}
        </v-icon>
      </v-card-title>
    </v-layout>
    <Summary></Summary>
    <Example></Example>
    <contact></contact>
  </v-card>
</template>

<script>
import Summary from './Summary'
import Example from './Example'
import contact from '../contact'

export default {
  data () {
    return {
      title: '受託開発',
      icon: 'mdi-charity'
    }
  },
  components: {
    Summary,
    Example,
    contact
  }
}
</script>
